module.exports = __webpack_public_path__ + "img/btn_confirm3_hdtool.b42b8eae.png";